import { AfterViewInit, Component, ElementRef, OnInit, Renderer2, ViewChild } from '@angular/core';
import { AbcisTableComponent, ABCisTableModel, ColumnType } from 'src/app/components/abcis-table/abcis-table.component';
import { ABCisApi } from 'src/app/handlers/apiHandler.service';
import { StoreSupplierSelectorComponent } from '../store-supplier-selector/store-supplier-selector.component';

@Component({
  selector: 'app-global-supplier-store-department-purchase-plu-config',
  standalone: false,
  templateUrl: './global-supplier-store-department-purchase-plu-config.component.html',
  styleUrls: ['./global-supplier-store-department-purchase-plu-config.component.scss']
})
export class GlobalSupplierStoreDepartmentPurchasePluConfigComponent implements OnInit, AfterViewInit {
  tableConfig: ABCisTableModel;
  globalSupplierStoreMapId;

  @ViewChild(AbcisTableComponent) abcisTableComponent: AbcisTableComponent;
  @ViewChild(StoreSupplierSelectorComponent) storeSupplierSelector: StoreSupplierSelectorComponent;

  constructor(private renderer: Renderer2,
    private el: ElementRef) { }

  ngOnInit(): void {
    this.SetTableConfig([], []);
  }

  SetTableConfig(storeId, supplierId) {
    const urlParams = [];
    if (storeId.length > 0) {
      urlParams.push({ name: 'storeId', value: storeId.join(',') });
    }
    if (supplierId.length > 0) {
      urlParams.push({ name: 'supplierId', value: supplierId.join(',') });
    }

    this.tableConfig = {
      apiConfig: {
        api: ABCisApi.Support,
        table: 'null',
        url: 'global-supplier-store-department-purchase-plu',
        urlParams: urlParams,
        approxamateRowCount: 1000,
        anyParams: true,
      },

      colConfig: [
        { field: 'globalSupplierStoreMapId', header: 'Global Supplier Store Map', type: ColumnType.MultiSelectComplex, setUrl: 'global-supplier-store-map/lookup', isReadonly: true, isPrimary: true },
        { field: 'departmentId', header: 'Department ID', type: ColumnType.DropDown, setUrl: 'global-department/lookup', isReadonly: true, isPrimary: true },
        { field: 'purchasePluExGst', header: 'Purchase Plu Ex Gst', type: ColumnType.String },
        { field: 'purchasePluIncGst', header: 'Purchase Plu Inc Gst', type: ColumnType.String }
      ],
      addFormConfig: {
        header: 'Add Global Supplier Store Department Purchase PLU'
      },
      isConfigurable: true
    };
  }

  ngAfterViewInit() {
    // default - disabled 'Add' button
    const addButton = this.el.nativeElement.querySelector('button[label="Add"]');
    this.renderer.setAttribute(addButton, 'disabled', 'true');
    // add form
    const mainAddForm = this.abcisTableComponent.showAddRowDialog;
    this.abcisTableComponent.showAddRowDialog = () => {
      mainAddForm.call(this.abcisTableComponent);

      setTimeout(() => {
        // Find the column and set its dataset
        const globalSupplierStoreMapColumn = this.abcisTableComponent.cols.find(col => col.field === 'globalSupplierStoreMapId');
        if (globalSupplierStoreMapColumn && globalSupplierStoreMapColumn.columnset) {
          const existingData = globalSupplierStoreMapColumn.columnset.find(item => item.value == this.storeSupplierSelector.globalSupplierStoreMapId);
          if (existingData) {
            globalSupplierStoreMapColumn.dataset = [existingData];
            globalSupplierStoreMapColumn.allowedInsertDataset = [existingData];
          }
        }
        this.abcisTableComponent.addingForm.get('globalSupplierStoreMapId').setValue(this.storeSupplierSelector.globalSupplierStoreMapId);
      }, 50);
    };

    // search
    const mainSearchSelector = this.storeSupplierSelector.onSearchClick;
    this.storeSupplierSelector.onSearchClick = () => {
      mainSearchSelector.call(this.storeSupplierSelector);
      this.SetTableConfig(this.storeSupplierSelector.selectedStoreId, this.storeSupplierSelector.selectedSupplierId);
    };
  }
}
